import type { ReactNode } from "react";
import type { Capability } from "./capabilities";
import { useCan } from "./use-can";

/**
 * Renders `children` only when the current user holds `can`. Silent-hides by
 * default (renders `fallback`, which is nothing unless provided). Pass a
 * `fallback` — usually `<AccessDenied />` — to intercept deep links at a route
 * boundary; leave it unset to hide in-page controls the user can't use.
 */
export const RoleGate: FCwC<{ can: Capability; fallback?: ReactNode }> = ({
  can,
  fallback = null,
  children,
}) => {
  const allowed = useCan(can);
  return <>{allowed ? children : fallback}</>;
};
